import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetAllUsersQuery } from "../../store/slice/tradeApi";
import { Loading } from "../../Components/Loading/Index";
import styles from "./admin.module.css";
import RoleModal from "./Components/RoleModal";
import DeleteModal from "./Components/DeleteModal";
import UserDetails from "./Components/UserDetails";

const ROLE_STYLES = {
  admin: styles.role_admin,
  user: styles.role_user,
  candidate: styles.role_candidate,
  banned: styles.role_banned,
};

function Admin() {
  const role = useSelector((state) => state.user.infos.role);
  const navigate = useNavigate();
  const { data: users, isLoading, isError } = useGetAllUsersQuery();

  // État pour les modals
  const [roleModal, setRoleModal] = useState(null);
  const [deleteModal, setDeleteModal] = useState(null);
  const [expandedUserId, setExpandedUserId] = useState(null);

  // Redirection si non admin
  useEffect(() => {
    if (role !== "admin") {
      navigate("/global");
    }
  }, [role, navigate]);

  const handleToggleDetails = (userId) => {
    setExpandedUserId(expandedUserId === userId ? null : userId);
  };

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  // Si non admin, ne rien afficher
  if (role !== "admin") return null;
  if (isLoading) return <Loading />;
  if (isError) return <p>Erreur lors du chargement des utilisateurs</p>;

  return (
    <main className={styles.admin}>
      <h1>Administration</h1>

      <p className={styles.userCount}>
        {users.length} utilisateur{users.length > 1 ? "s" : ""}
      </p>

      <table className={styles.usersTable}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Alias</th>
            <th>Email</th>
            <th>Inscrit</th>
            <th>Rôle</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <React.Fragment key={user.id}>
              <tr>
                <td>{user.id}</td>
                <td>{user.alias}</td>
                <td title={user.email}>{user.email}</td>
                <td>{formatDate(user.regDate)}</td>
                <td className={ROLE_STYLES[user.role] || ""}>
                  {user.role}
                </td>
                <td>
                  <div className={styles.actions}>
                    <button
                      className={`${styles.btnSmall} ${styles.btnRole}`}
                      onClick={() => setRoleModal(user)}
                      title="Modifier le rôle"
                    >
                      Rôle
                    </button>
                    <button
                      className={`${styles.btnSmall} ${styles.btnDetails}`}
                      onClick={() => handleToggleDetails(user.id)}
                      title="Voir les détails"
                    >
                      {expandedUserId === user.id ? "Fermer" : "Détails"}
                    </button>
                    <button
                      className={`${styles.btnSmall} ${styles.btnDelete}`}
                      onClick={() => setDeleteModal(user)}
                      title="Supprimer l'utilisateur"
                    >
                      Suppr.
                    </button>
                  </div>
                </td>
              </tr>
              {expandedUserId === user.id && (
                <tr className={styles.detailsRow}>
                  <td colSpan="6">
                    <UserDetails userId={user.id} />
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>

      {/* Modal changement de rôle */}
      {roleModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(49,49,49,0.8)",
            zIndex: 10,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => setRoleModal(null)}
        >
          <div
            style={{
              background: "#f1f1f1",
              padding: "28px",
              borderRadius: "10px",
              maxWidth: "400px",
              minWidth: "300px",
              position: "relative",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <RoleModal user={roleModal} onClose={() => setRoleModal(null)} />
          </div>
        </div>
      )}

      {/* Modal suppression */}
      {deleteModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(49,49,49,0.8)",
            zIndex: 10,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => setDeleteModal(null)}
        >
          <div
            style={{
              background: "#f1f1f1",
              padding: "28px",
              borderRadius: "10px",
              maxWidth: "450px",
              minWidth: "300px",
              position: "relative",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <DeleteModal
              user={deleteModal}
              onClose={() => setDeleteModal(null)}
            />
          </div>
        </div>
      )}
    </main>
  );
}

export default Admin;
